module.exports = __webpack_public_path__ + "static/media/banner-Banner-Compliance-2026-licitacao-14133.8b3840a4.png";